/**
 * Polyfills for evergreen browsers (browserslist excludes IE).
 *
 * ES2017+ natives (Object.values, Array/Map/Set/Symbol, fetch, native Reflect, etc.) are built into
 * every supported target, so the former core-js/es/* + object.values + unfetch shims were removed.
 * Only two things still need loading:
 *   - Symbol.observable: not native (stage-1 proposal); required for the mobx-utils <-> RxJS interop.
 *   - Zone.js: required by Angular.
 */
import 'core-js/features/symbol/observable';
import 'zone.js';
